export default __webpack_public_path__ + "public/images/home/intro/turquoiseStar.png?ce8b24c0";